import { Button } from "primereact/button";

import { Icon } from "@/ds";
import { ListaToolbar } from "@/shared/components/lista-toolbar";
import { QuickMultiSelectFilter } from "@/shared/components/quick-multi-select-filter";
import styles from "../../obras-screen.module.scss";
import { ObrasDateFilter } from "./components/obras-date-filter";
import type { ObrasToolbarViewModel } from "./types-obras-toolbar";

/** Barra da listagem: a barra compartilhada com status, período e "Nova Obra". */
export function ObrasToolbarView({
  isMobile,
  view,
  onViewChange,
  search,
  onSearchChange,
  statusValue,
  statusOptions,
  isStatusDisabled,
  onStatusChange,
  onStatusClear,
  range,
  onRangeChange,
  filterDefinitions,
  filterValue,
  onFilterChange,
  savedFilters,
  onSaveFilter,
  onDeleteSavedFilter,
  onApplySavedFilter,
  onExport,
  onOpenSettings,
  showStatusAndDate,
  controlSize,
  goToNova,
}: ObrasToolbarViewModel) {
  return (
    <ListaToolbar
      testIdPrefix="obras"
      isMobile={isMobile}
      view={view}
      onViewChange={onViewChange}
      search={search}
      onSearchChange={onSearchChange}
      quickFilters={
        showStatusAndDate ? (
          <>
            <QuickMultiSelectFilter
              className={styles.statusSelect}
              value={statusValue}
              options={statusOptions}
              optionValue="code"
              placeholder="Status da Obra"
              disabled={isStatusDisabled}
              onChange={onStatusChange}
              onClear={onStatusClear}
              aria-label="Status da Obra"
              data-testid="obras-status-filter"
            />
            <ObrasDateFilter range={range} onChange={onRangeChange} />
          </>
        ) : null
      }
      actionsEnd={
        <Button
          type="button"
          className={styles.newButton}
          icon={<Icon name="plus" size={14} />}
          label="Nova Obra"
          size={controlSize}
          onClick={goToNova}
          data-testid="obras-nova"
        />
      }
      filterDefinitions={filterDefinitions}
      filterValue={filterValue}
      onFilterChange={onFilterChange}
      savedFilters={savedFilters}
      onSaveFilter={onSaveFilter}
      onDeleteSavedFilter={onDeleteSavedFilter}
      onApplySavedFilter={onApplySavedFilter}
      onExport={onExport}
      onOpenSettings={onOpenSettings}
    />
  );
}
